const validationPropsDefaults = {
  rules: () => [],
  dirty: false,
  errorCount: 1,
  success: false,
  messages: () => [],
  immediateValidation: false
};
export {
  validationPropsDefaults as v
};
//# sourceMappingURL=useValidation.props.js.map
